import styled from "styled-components";

export const PriceBreakupTitle = styled.div`
  margin-bottom: 16px;
`;

export const PriceBreakupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
`;

export const BreakupSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ExtraChargesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FinalAmountSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const BreakupItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-family: Lato, sans-serif;
  line-height: 100%;
  letter-spacing: 0;
`;
